/**
 * Flavor list scroll for the mm-bundlekit section (setting "Scrollable flavor list").
 *
 * Turns #mm-bundle__items into a scroll box that shows N full rows plus a peek of
 * the next one, with a custom scroll bar that is always visible (iOS Safari hides
 * native scroll bars, so they can't be styled to stay on screen).
 *
 * Modes (data-mm-items-scroll):
 *   on  - always active.
 *   ab  - active only while <html> has the class sl-ab-flavor-scroll, which the
 *         A/B tool adds for the variant. The class may arrive after this script
 *         runs, so <html> is watched for it.
 *
 * Rows are rendered by Alpine (x-for), after this script loads, and change height
 * when a flavor is added, so the height is re-measured whenever rows appear or resize.
 */
(function () {
  var AB_CLASS = 'sl-ab-flavor-scroll';

  function isEnabled(root) {
    var mode = root.getAttribute('data-mm-items-scroll');
    if (mode === 'on') return true;
    if (mode === 'ab') return document.documentElement.classList.contains(AB_CLASS);
    return false;
  }

  function setup(root) {
    if (root.__mmItemsScroll) return root.__mmItemsScroll;

    var list = root.querySelector('.mm-bundle__items');
    var bar = root.querySelector('.mm-bundle__items-bar');
    var thumb = root.querySelector('.mm-bundle__items-thumb');
    if (!list || !bar || !thumb) return null;

    var visible = parseInt(root.getAttribute('data-visible'), 10) || 4;
    var peek = (parseInt(root.getAttribute('data-peek'), 10) || 35) / 100;
    var frame = 0;

    function rows() {
      return list.querySelectorAll(':scope > .mm-bundle__item');
    }

    function updateThumb() {
      var max = list.scrollHeight - list.clientHeight;
      var trackH = bar.clientHeight;
      if (max <= 0 || trackH <= 0) return;
      var thumbH = Math.max(24, Math.round((list.clientHeight / list.scrollHeight) * trackH));
      var y = Math.round((list.scrollTop / max) * (trackH - thumbH));
      root.style.setProperty('--mm-items-thumb-h', thumbH + 'px');
      root.style.setProperty('--mm-items-thumb-y', y + 'px');
    }

    function measure() {
      frame = 0;
      var items = rows();
      // With N or fewer rows there is nothing to scroll; show the plain list.
      if (!isEnabled(root) || items.length <= visible) {
        root.classList.remove('is-active');
        root.style.removeProperty('--mm-items-scroll-h');
        return;
      }
      root.classList.add('is-active');
      var next = items[visible];
      var h = next.offsetTop + next.offsetHeight * peek;
      root.style.setProperty('--mm-items-scroll-h', Math.round(h) + 'px');
      updateThumb();
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(measure);
    }

    // Rows appear (Alpine), get replaced, or change height (Add + becomes a stepper).
    var resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(list);
    function observeRows() {
      rows().forEach(function (row) {
        resizeObserver.observe(row);
      });
    }
    new MutationObserver(function () {
      observeRows();
      schedule();
    }).observe(list, { childList: true });
    observeRows();

    list.addEventListener('scroll', updateThumb, { passive: true });

    // Drag the bar (or click the track) to scroll the list.
    bar.addEventListener('pointerdown', function (e) {
      if (!root.classList.contains('is-active')) return;
      e.preventDefault();
      bar.setPointerCapture(e.pointerId);
      var rect = bar.getBoundingClientRect();
      var thumbH = thumb.offsetHeight;
      var thumbTop = thumb.getBoundingClientRect().top;
      var onThumb = e.clientY >= thumbTop && e.clientY <= thumbTop + thumbH;
      // Keep the grab point under the pointer; a track click centres the thumb there.
      var grab = onThumb ? e.clientY - thumbTop : thumbH / 2;

      function moveTo(clientY) {
        var range = rect.height - thumbH;
        if (range <= 0) return;
        var ratio = Math.min(1, Math.max(0, (clientY - rect.top - grab) / range));
        list.scrollTop = ratio * (list.scrollHeight - list.clientHeight);
      }

      if (!onThumb) moveTo(e.clientY);

      function onMove(ev) {
        moveTo(ev.clientY);
      }
      function onUp() {
        bar.removeEventListener('pointermove', onMove);
        bar.removeEventListener('pointerup', onUp);
        bar.removeEventListener('pointercancel', onUp);
      }
      bar.addEventListener('pointermove', onMove);
      bar.addEventListener('pointerup', onUp);
      bar.addEventListener('pointercancel', onUp);
    });

    root.__mmItemsScroll = { schedule: schedule };
    schedule();
    return root.__mmItemsScroll;
  }

  function initAll() {
    document.querySelectorAll('[data-mm-items-scroll]').forEach(setup);
  }

  function refreshAll() {
    document.querySelectorAll('[data-mm-items-scroll]').forEach(function (root) {
      var instance = setup(root);
      if (instance) instance.schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // The A/B tool may add the class after load.
  new MutationObserver(refreshAll).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  window.addEventListener('load', refreshAll);
  document.addEventListener('shopify:section:load', initAll);
})();
